import type { Job } from './types'

/** A completed parallel job must not hide work that is still in flight. */
export function currentJob(jobs: Job[]) {
  const latest = [...jobs].sort((a, b) => b.created_at.localeCompare(a.created_at) || b.id.localeCompare(a.id))
  return latest.find(job => job.status === 'running') || latest.find(job => job.status === 'queued') || latest[0]
}
